import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons/faFacebookMessenger';
import { faGooglePlusG } from '@fortawesome/free-brands-svg-icons/faGooglePlusG';
import { faLine } from '@fortawesome/free-brands-svg-icons/faLine';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faMix } from '@fortawesome/free-brands-svg-icons/faMix';
import { faPinterestP } from '@fortawesome/free-brands-svg-icons/faPinterestP';
import { faRedditAlien } from '@fortawesome/free-brands-svg-icons/faRedditAlien';
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons/faTelegramPlane';
import { faTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faVk } from '@fortawesome/free-brands-svg-icons/faVk';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faXing } from '@fortawesome/free-brands-svg-icons/faXing';

import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCoffee } from '@fortawesome/free-solid-svg-icons/faCoffee';
import { faCommentAlt } from '@fortawesome/free-solid-svg-icons/faCommentAlt';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';

export const icons = [
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faGooglePlusG,
  faPinterestP,
  faRedditAlien,
  faTumblr,
  faWhatsapp,
  faVk,
  faFacebookMessenger,
  faTelegramPlane,
  faMix,
  faXing,
  faCommentAlt,
  faBook,
  faLine,
  faEnvelope,
  faCheck,
  faPrint,
  faExclamation,
  faLink,
  faEllipsisH,
  faMinus,
  faLightbulb,
  faCoffee,
  faInfo,
];
